import { createContext, useContext, type ReactNode } from 'react';
import type { SupportLinks } from '../config/schema.ts';

const SupportContext = createContext<SupportLinks>({ mode: 'none' });

export const SupportProvider = ({ links, children }: { links: SupportLinks; children: ReactNode }) => (
  <SupportContext.Provider value={links}>{children}</SupportContext.Provider>
);

export const useSupportLinks = (): SupportLinks => useContext(SupportContext);
